import React from 'react'
import Paginator from '../components/PaginatorComponent'

import '../style.css'

class PaginatorContainer extends React.Component {
  state = {
    page: '1'
  }

  onTextChange = (e) => {
    if (e.target.value === '') {
      this.setState({ page: '' })
      return
    }
    const newPage = parseInt(e.target.value)
    if (isNaN(newPage)) return
    if (newPage > this.props.control.pages) {
      this.setState({ page: this.props.control.pages })
      return
    }
    if (newPage < 1) {
      this.setState({ page: 1 })
      return
    }
    this.setState({ page: newPage })
    this.props.click(newPage - 1)
  }

  onClick = (dif) => {
    console.log(dif)
    this.setState({ page: parseInt(dif) + 1 })
    this.props.click(dif)
  }

  setPage = (page) => { this.setState({ page }) }

  render() {
    return (
      <Paginator textChange={this.onTextChange} control={this.props.control} click={this.onClick} page={parseInt(this.props.control.page) + 1} />
    )
  }
}

export default PaginatorContainer
